export function hasSavedThing(rankings, userId, thingId) {
  const ranking = rankings?.[userId];
  if (!ranking) return false;
  if ((ranking.ratings?.[thingId] || 0) > 0) return true;
  return Array.isArray(ranking.vetos) && ranking.vetos.includes(thingId);
}

export function savedThingIdsForUser(rankings, userId) {
  const ranking = rankings?.[userId];
  if (!ranking) return [];
  const ids = new Set();
  Object.entries(ranking.ratings || {}).forEach(([id, stars]) => {
    if (stars > 0) ids.add(id);
  });
  (ranking.vetos || []).forEach((id) => ids.add(id));
  return [...ids];
}

export function hasSavedVeto(rankings, userId) {
  return (rankings?.[userId]?.vetos || []).length > 0;
}

export function getVetoCount(rankings, thingId) {
  let count = 0;
  for (const ranking of Object.values(rankings || {})) {
    if (ranking?.vetos?.includes(thingId)) count += 1;
  }
  return count;
}

export function getAverageRating(rankings, thingId) {
  let sum = 0;
  let count = 0;
  for (const ranking of Object.values(rankings || {})) {
    const stars = ranking?.ratings?.[thingId];
    if (stars > 0) {
      sum += stars;
      count += 1;
    }
  }
  return count > 0 ? sum / count : 0;
}

export function getVoters(names, rankings, thingId) {
  return (names || []).filter((person) => hasSavedThing(rankings, person.id, thingId));
}

export function lockedCountForUser(rankings, userId, things) {
  return (things || []).filter((thing) => hasSavedThing(rankings, userId, thing.id)).length;
}

export function rankSavedThings(things, rankings, savedIds) {
  const list = things || [];
  const minVetoes = list.length
    ? Math.min(...list.map((thing) => getVetoCount(rankings, thing.id)))
    : 0;

  const options = [];
  const moreVetoed = [];
  const savedSet = new Set(savedIds || []);

  list.forEach((thing) => {
    if (!savedSet.has(thing.id)) return;
    const vetoCount = getVetoCount(rankings, thing.id);
    const row = {
      ...thing,
      vetoCount,
      averageRating: getAverageRating(rankings, thing.id)
    };
    if (vetoCount === minVetoes) options.push(row);
    else moreVetoed.push(row);
  });

  options.sort((a, b) => {
    if (a.averageRating === 0 && b.averageRating === 0) return 0;
    if (a.averageRating === 0) return 1;
    if (b.averageRating === 0) return -1;
    return b.averageRating - a.averageRating;
  });

  return { options, moreVetoed, minVetoes };
}
